import React, { useEffect, useState } from 'react';
import { FaBars } from 'react-icons/fa';
import { AiFillGithub } from 'react-icons/ai';
import { IconContext } from 'react-icons/lib';
import { Nav, NavbarContainer, NavLogo, MobileIcons, NavMenu, NavItem, NavLinks, NavBtn, NavBtnLink, NavIcon } from './NavbarElements';

const Navbar = ({ toggle }) => {

    const [scrollNav, setScrollNav] = useState(false);

    const changeNav = () => {
        if (window.scrollY >= 80) {
            setScrollNav(true);
        } else {
            setScrollNav(false);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', changeNav);
    }, [])

    return (
        <>
            <IconContext.Provider value={{ color: '#fff' }}>
                <Nav
                    initial={{ opacity: 0.3, y: -100 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    scrollNav={scrollNav}
                >
                    <NavbarContainer>
                        <NavLogo href="https://github.com/IshTakkar" target="_blank">
                            <AiFillGithub />
                            <NavIcon>.com/IshTakkar</NavIcon>
                        </NavLogo>

                        <MobileIcons onClick={toggle}>
                            <FaBars />
                        </MobileIcons>
                        <NavMenu>
                            <NavItem>
                                <NavLinks to="about"
                                    smooth={true} duration={500} spy={true} exact="true" offset={-80}
                                >About</NavLinks>
                            </NavItem>
                            <NavItem>
                                <NavLinks to="expertise"
                                    smooth={true} duration={500} spy={true} exact="true" offset={-80}
                                >Expertise</NavLinks>
                            </NavItem>
                            <NavItem>
                                <NavLinks to="projects"
                                    smooth={true} duration={500} spy={true} exact="true" offset={-80}
                                >Projects</NavLinks>
                            </NavItem>
                            <NavItem>
                                <NavLinks to="socials"
                                    smooth={true} duration={500} spy={true} exact="true" offset={-80}
                                >Socials</NavLinks>
                            </NavItem>
                        </NavMenu>
                        {/* <NavBtn>
                            <NavBtnLink to="/signin">Sign In</NavBtnLink>
                        </NavBtn> */}
                    </NavbarContainer>
                </Nav>
            </IconContext.Provider>
        </>
    );
};

export default Navbar;